import { ChangeEvent, useMemo, useState } from "react";

import { SearchOutlined } from "@ant-design/icons";
import { debounce } from "lodash-es";

import { Input } from "antd";

interface CmtSearchFilterProps {
  defaultValue: string | undefined;
  placeholder: string;
  onQueryChange: (value: string) => void;
}

export function CmtSearchFilter({
  defaultValue,
  placeholder,
  onQueryChange,
}: Readonly<CmtSearchFilterProps>) {
  const [inputValue, setInputValue] = useState(defaultValue ?? "");
  const [previousDefaultValue, setPreviousDefaultValue] =
    useState(defaultValue);

  const debouncedQueryChange = useMemo(
    () => debounce(onQueryChange, 400),
    [onQueryChange],
  );

  if (defaultValue !== previousDefaultValue) {
    debouncedQueryChange.cancel();
    setPreviousDefaultValue(defaultValue);
    setInputValue(defaultValue ?? "");
  }

  const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setInputValue(value);
    debouncedQueryChange(value);
  };

  return (
    <Input
      value={inputValue}
      style={{ flex: "1 1 220px", maxWidth: 320 }}
      prefix={<SearchOutlined style={{ opacity: 0.5 }} />}
      allowClear
      placeholder={placeholder}
      onChange={handleSearch}
    />
  );
}
